module.exports = __webpack_public_path__ + "static/media/hybrid.6bfe6ba0.png";